module.exports = __webpack_public_path__ + "img/chevron-left.5727f869.svg";